import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import Datafeed from '../../mydatafeed/datafeed';
import axios from "axios";
import { API_URL } from '../../api-config';
import LoadingChart from '../LoadingChart';
import {
	atrModelMetadataConfig, averagePriceMetadataConfig,
	balanceadorMetadataConfig, trendStrengthMetadataConfig,
	volumeTakerSideMetadataConfig, atrMath, balanceadorMath, avgPriceMath, trendStrengthMath,
	volumeTakerSideMath
} from './balanceador_config';


function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}





const supported_resolutions = ['5', '1H', '1D', '1W']
export const TVCharBalanceador = () => {
	const [toolboxData, setToolboxData] = useState({});
	const [atrData, setAtrData] = useState({});
	const [isLoading, setIsLoading] = useState(true);
	const chartContainerRef = useRef();
	const [widgetReady, setWidgetReady] = useState(false);
	const tvWidgetRef = useRef(null);
	const studiesRef = useRef({});
	const fetchIndicators = async () => {

		try {
			const limit = 2500
			const [balanceadorResponse, polarizadorResponse, indicadorFuerzaResponse, avgPriceResponse, takerSideResponse] = await Promise.all([
				axios.get(`${API_URL}/trading-api/toolbox/balanceador/?limit=${limit}`, {
					headers: { "accept": "application/json" }
				}),
				axios.get(`${API_URL}/trading-api/toolbox/polarizador/?limit=${limit}`, {
					headers: { "accept": "application/json" }
				}),
				axios.get(`${API_URL}/trading-api/toolbox/indicador_de_fuerza/?limit=${limit}`, {
					headers: { "accept": "application/json" }
				}),
				axios.get(`${API_URL}/trading-api/toolbox/avg_price_2/?limit=${limit}`, {
					headers: { "accept": "application/json" }
				}),
				axios.get(`${API_URL}/trading-api/toolbox/taker_side/?limit=${limit}`, {
					headers: { "accept": "application/json" }
				})
			]);

			// Crear un diccionario con los datos etiquetados por nombre de indicador
			const toolboxData = {
				balanceador: balanceadorResponse.data,
				polarizador: polarizadorResponse.data,
				fuerza: indicadorFuerzaResponse.data,
				avgPrice: avgPriceResponse.data,
				takerSide: takerSideResponse.data

			};
			console.log("Toolbox data", toolboxData)

			return toolboxData;

		} catch (error) {
			console.error("Error fetching indicators", error);
			return null;
		}
	};

	const getData = async (load) => {
		if (load) {
			setIsLoading(true);
		}
		// 
		try {
			let toolbox_data = await fetchIndicators();
			setToolboxData(toolbox_data);

			const atrResponse = await axios.get(
				`${API_URL}/trading-api/toolbox/atr_model/?limit=2000`,
				{
					headers: {
						"accept": "application/json",
					}
				}
			);
			setAtrData({ "atr": atrResponse.data });
		} catch (error) {
			console.error("Error loading data:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetchToolboxData = async () => {
		await getData(true)
	}
	useEffect(() => {
		fetchToolboxData()

	}, [])
	const defaultProps = {
		symbol: 'USDCLP',
		interval: '5',
		datafeedUrl: 'https://demo_feed.tradingview.com',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		autosize: false,
		studiesOverrides: {},
	};


	useEffect(() => {
		const initializeWidget = async () => {
			if (!isLoading && chartContainerRef.current && !widgetReady) {
				try {
					const widgetOptions = {
						symbol: defaultProps.symbol,
						// BEWARE: no trailing slash is expected in feed URL
						datafeed: Datafeed,
						interval: defaultProps.interval,
						container: chartContainerRef.current,
						library_path: defaultProps.libraryPath,
						theme: "dark",
						style: "3",
						timezone: "America/Santiago",
						locale: getLanguageFromURL() || 'en',
						disabled_features: ['use_localstorage_for_settings'],
						enabled_features: ['study_templates'],
						charts_storage_url: defaultProps.chartsStorageUrl,
						charts_storage_api_version: defaultProps.chartsStorageApiVersion,
						//client_id: defaultProps.clientId,
						user_id: defaultProps.userId,
						fullscreen: defaultProps.fullscreen,
						autosize: defaultProps.autosize,
						studies_overrides: defaultProps.studiesOverrides,
						height: '80%',
						width: '95%',
						supported_resolutions: supported_resolutions,
						// eslint-disable-next-line no-unused-vars
						custom_indicators_getter: function (PineJS) {
							return Promise.resolve([



								{
									name: 'Balanceador Toolbox',
									metainfo: balanceadorMetadataConfig,
									constructor: function () {
										this.init = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;
											const symbol = 'AAPL'; // #EQUITY should be replaced with the symbol you want to resolve
											this._context.new_sym(symbol, PineJS.Std.period(this._context));
										};

										this.main = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;

											this._context.select_sym(0);
											var fecha = new Date(this._context.symbol.time)

											return balanceadorMath(fecha, toolboxData)
										}
									}
								}, {
									name: 'QRT AVERAGE PRICE',
									metainfo: averagePriceMetadataConfig,
									constructor: function () {
										this.init = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;

											const symbol = 'AAPL'; // #EQUITY should be replaced with the symbol you want to resolve
											this._context.new_sym(symbol, PineJS.Std.period(this._context));
										};

										this.main = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;
											// Select the main symbol
											this._context.select_sym(0);

											this._context.select_sym(0);
											var fecha = new Date(this._context.symbol.time)
											return avgPriceMath(fecha, toolboxData)
										}
									}
								}, {
									name: 'Trend Strength',
									metainfo: trendStrengthMetadataConfig,
									constructor: function () {
										this.main = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;
											this._context.select_sym(0);
											var fecha = new Date(this._context.symbol.time)
											return trendStrengthMath(fecha, toolboxData)

										}
									}
								},
								{
									name: 'Volume Taker side',
									metainfo: volumeTakerSideMetadataConfig,
									constructor: function () {
										this.main = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;
											this._context.select_sym(0);
											var fecha = new Date(this._context.symbol.time)

											return volumeTakerSideMath(fecha, toolboxData)
										}
									}
								},
								{
									name: 'ATR Model',
									metainfo: atrModelMetadataConfig,
									constructor: function () {
										this.init = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;


											const symbol = 'AAPL'; // #EQUITY should be replaced with the symbol you want to resolve
											this._context.new_sym(symbol, PineJS.Std.period(this._context));
										};

										this.main = function (context, inputCallback) {
											this._context = context;
											this._input = inputCallback;

											this._context.select_sym(0);
											var fecha = new Date(this._context.symbol.time)


											return atrMath(fecha, atrData)
										}

									}
								}


							]);
						}
					}


					const tvWidget = new widget(widgetOptions);
					tvWidgetRef.current = tvWidget;
					tvWidget.onChartReady(() => {

						tvWidget.chart().createStudy('Trend Strength', false, false);
						tvWidget.chart().createStudy('ATR MODEL', false, false)
						tvWidget.chart().createStudy('QRT AVERAGE PRICE', false, false)
						// tvWidget.chart().createStudy('Volume Taker Side', false, false)
						tvWidget.chart().createStudy('Balanceador Toolbox', false, false)
					});
					tvWidgetRef.current = tvWidget.chart();
					setWidgetReady(true);

					return () => {
						if (tvWidget !== null) {
							tvWidget.remove();
						}
					};
				} catch (error) {
					console.error('Error initializing TradingView widget:', error);
				}
			}
		};


		initializeWidget();

		return () => {
			if (tvWidgetRef.current) {
				tvWidgetRef.current.remove();
				tvWidgetRef.current = null;
			}
		};



	}, [isLoading]);
	useEffect(() => {
		const interval = setInterval(async () => {
			console.log("Actualizando indicadores...");
			await getData(false); // Obtiene la data actualizada
			if (tvWidgetRef.current) {
				const chart = tvWidgetRef.current.chart();

				// Eliminar estudios existentes si los hay
				// Object.values(studiesRef.current).forEach((studyId) => {
				// 	chart.removeEntity("BarColoring@tv-basicstudies-1");
				// });
				chart.removeAllStudies()
				studiesRef.current = {};

				// // Crear los estudios y guardar sus IDs
				studiesRef.current.trendStrength = chart.createStudy('Trend Strength', false, false);
				studiesRef.current.atr = chart.createStudy('ATR MODEL', false, false);
				studiesRef.current.avgPrice = chart.createStudy('QRT AVERAGE PRICE', false, false);
				// studiesRef.current.takerSide = chart.createStudy('Volume Taker Side', false, false);

				// Si tienes otro indicador (por ejemplo, Balanceador Toolbox)
				studiesRef.current.balanceador = chart.createStudy('Balanceador Toolbox', false, false);
			}
		}, 60000); // 60000 ms = 1 minuto
		return () => clearInterval(interval);
	}, []);
	if (isLoading && !widgetReady) {
		return <LoadingChart />;
	}
	return (
		<div className={'h-screen w-screen m-1'}>
			<div
				ref={chartContainerRef}
				className="w-full h-screen"
			/>
		</div>
	);
}
